import { __getCommonSettings } from '../selectors';
import {
  BREAKPOINT_400,
  BREAKPOINT_502,
  BREAKPOINT_640,
  BREAKPOINT_800,
  BREAKPOINT_1004,
  BREAKPOINT_1280,
  BREAKPOINT_767,
} from './constants';

const getBreakpointsData = __getCommonSettings;
/**
 * !!! private - Please restrain from using this selector in components
 * Use isScreenBelowXXX instead
 */
export const isDetectedDeviceMobile = (state) => getBreakpointsData(state).isMobileDevice;
export const getBreakpointByDevice = (state) =>
  isDetectedDeviceMobile(state) ? BREAKPOINT_502 : BREAKPOINT_1004;
export const getLastKnownResolution = (state) => getBreakpointsData(state).lastKnownResolution;
export const hasLastKnownResolution = (state) => typeof getLastKnownResolution(state) === 'number';

/**
 * use lastKnownResolution if it is an actual number, otherwise detect resolution by device
 */
export const getBreakpoint = (state) =>
  hasLastKnownResolution(state) ? getLastKnownResolution(state) : getBreakpointByDevice(state);

export const getLastKnownResolutionCookieName = (state) =>
  getBreakpointsData(state).lastKnownResolutionCookieName;

/**
 * Selectors for breakpoints, top resolution is INCLUDED in interval
 */
export const isScreenBelow400 = (state) => getBreakpoint(state) < BREAKPOINT_400;
export const isScreenBelow502 = (state) => getBreakpoint(state) < BREAKPOINT_502;
export const isScreenBelow640 = (state) => getBreakpoint(state) < BREAKPOINT_640;
export const isScreenBelow767 = (state) => getBreakpoint(state) < BREAKPOINT_767;
export const isScreenBelow800 = (state) => getBreakpoint(state) < BREAKPOINT_800;
export const isScreenBelow1004 = (state) => getBreakpoint(state) < BREAKPOINT_1004;
export const isScreenBelow1280 = (state) => getBreakpoint(state) < BREAKPOINT_1280;
